import { styled } from '@material-ui/core';
import { Calendar } from 'react-multi-date-picker';
import { isCapitalUI } from '../react-common/theme';
import { capitalTokens } from '../react-common/capitalTheme';
import { alpha } from '@material-ui/core/styles/colorManipulator';
//export const russian: CalendarLocalization = {
//    name: 'ru',
//    startYear: 1,
//    yearLength: 365,
//    epoch: 0,
//    century: 0,
//    weekStartDayIndex: 0,
//    getMonthLengths: function(isLeap: boolean): number[] {
//        throw new Error('Function not implemented.')
//    },
//    isLeap: function(year: number): boolean {
//        throw new Error('Function not implemented.')
//    },
//    getLeaps: function(currentYear: number): number[] | [] {
//        throw new Error('Function not implemented.')
//    },
//    getDayOfYear: function(date: DateObject): number {
//        throw new Error('Function not implemented.')
//    },
//    getAllDays: function(date: DateObject): number {
//        throw new Error('Function not implemented.')
//    },
//    guessYear: function(days: number, currentYear: number): number {
//        throw new Error('Function not implemented.')
//    }
//}
export const russian = {
    name: 'ru',
    months: [
        ['Январь', 'Янв'],
        ['Февраль', 'Фев'],
        ['Март', 'Мар'],
        ['Апрель', 'Апр'],
        ['Май', 'Май'],
        ['Июнь', 'Июн'],
        ['Июль', 'Июл'],
        ['Август', 'Авг'],
        ['Сентябрь', 'Сен'],
        ['Октябрь', 'Окт'],
        ['Ноябрь', 'Ноя'],
        ['Декабрь', 'Дек'],
    ],
    weekDays: [
        ['Суббота', 'Сб'],
        ['Воскресенье', 'Вс'],
        ['Понедельник', 'Пн'],
        ['Вторник', 'Вт'],
        ['Среда', 'Ср'],
        ['Четверг', 'Чт'],
        ['Пятница', 'Пт'],
    ],
    digits: ["0", "1", "2", "3", "4", "5", "6", "7", "8", "9"],
    meridiems: []
};
export const StyledCalendar = styled(Calendar)(({ theme }) => {
    const selectedText = theme.palette.primary.contrastText;
    const rangeSurface = alpha(theme.palette.primary.main, .12);
    const hoverSurface = alpha(theme.palette.primary.main, .12);
    return Object.assign({ fontFamily: theme.typography.fontFamily, '&.rmdp-wrapper, & .rmdp-month-picker, & .rmdp-year-picker, & .rmdp-time-picker div input, .rmdp-container &.ep-arrow::after': {
            backgroundColor: theme.palette.background.paper,
            color: theme.palette.text.primary,
            mx: 'auto',
        }, '& .rmdp-day:not(.rmdp-deactive), & .rmdp-time-picker div .rmdp-am, & .rmdp-header-values, & .rmdp-panel-header': {
        //color: theme.palette.primary.light,
        }, '& .rmdp-header-values': {
            fontWeight: 'bold',
        }, '& .rmdp-day, & .rmdp-week-day': {
            width: '40px',
            height: '40px',
            padding: '5px',
        }, '& .rmdp-day span, & .rmdp-header, & .rmdp-month-name': {
            fontSize: '13px',
        }, '& .rmdp-day span.sd': {
            fontSize: '13px',
            fontWeight: 'bold',
        }, 
        // The library paints single dates on a round span and ranges on its parent.
        // Keep one shape and one background layer for every selection state.
        '& .rmdp-day, & .rmdp-day:not(.rmdp-range):focus, & .rmdp-day span': {
            borderRadius: 4,
        }, '& .rmdp-panel-body li': {
            color: theme.palette.primary.contrastText,
            border: `1px solid ${theme.palette.primary.main}`,
            boxShadow: `0 0 5px ${theme.palette.primary.main}`,
            background: `${theme.palette.primary.main} !important`,
            //boxShadow: theme.shadows[5],
        }, '& .rmdp-day.rmdp-deactive, & .rmdp-day.rmdp-disabled': {
            color: theme.palette.text.disabled,
        }, '& .rmdp-day.rmdp-disabled span': {
            textDecoration: 'line-through',
        }, 
        //'& .rmdp-day:not(.rmdp-disabled):not(.rmdp-range)': {
        //    backgroundColor: `#D0D6FF !important`,
        //},
        '.rmdp-container &.ep-arrow[direction="top"]': {
            borderBottom: `1px solid ${theme.palette.secondary.main}`,
        }, '.rmdp-container &.ep-arrow[direction="left"]': {
            borderRight: `1px solid ${theme.palette.secondary.main}`,
        }, '.rmdp-container &.ep-arrow[direction="right"]': {
            borderLeft: `1px solid ${theme.palette.secondary.main}`,
        }, '.rmdp-container &.ep-arrow[direction="bottom"]': {
            borderTop: `1px solid ${theme.palette.secondary.main}`,
        }, '&.rmdp-wrapper.rmdp-shadow': {
            border: `1px solid ${theme.palette.secondary.main}`,
            boxShadow: `0 0 5px ${theme.palette.secondary.main}`,
            //...(error && {
            //    borderColor: theme.palette.error.main,
            //}),
        }, '& .rmdp-week-day': {
            color: theme.palette.common.black,
            fontWeight: 'bold',
        }, '& .rmdp-day.rmdp-deactive': {
            color: '#999',
        }, '& .rmdp-day.rmdp-range, & .rmdp-day.rmdp-range-hover': {
            backgroundColor: rangeSurface,
            borderRadius: 0,
            boxShadow: 'none',
            color: theme.palette.common.black,
        }, '& .rmdp-arrow': {
            border: `solid ${theme.palette.common.black}`,
            borderWidth: `0 3px 3px 0`,
            height: '4px',
            width: '4px',
            padding: '3px',
            marginTop: '16px',
        }, '& .rmdp-arrow-container': {
            width: '40px',
            height: '40px',
        }, '& .rmdp-arrow-container:hover': {
            borderRadius: '4px',
            backgroundColor: theme.palette.grey[200],
            boxShadow: `none`,
        }, '& .rmdp-panel-body::-webkit-scrollbar-thumb': {
            background: `${theme.palette.primary.main} !important`,
        }, '& .rmdp-day.rmdp-today span': {
            backgroundColor: hoverSurface,
            color: theme.palette.common.black,
        }, '& .rmdp-rtl .rmdp-panel': {
            borderLeft: 'unset',
            borderRight: `1px solid ${theme.palette.secondary.main}`,
        }, '& .rmdp-day.rmdp-selected': {
            backgroundColor: theme.palette.primary.main,
            color: selectedText,
        }, '& .rmdp-day:not(.rmdp-disabled):not(.rmdp-day-hidden):not(.rmdp-range):not(.rmdp-range-hover):not(.rmdp-selected) span:hover': {
            background: hoverSurface,
            color: theme.palette.common.black,
        }, '& .rmdp-day.rmdp-disabled span:hover': {
            background: 'transparent',
            color: theme.palette.text.disabled,
            cursor: 'not-allowed',
        }, '& .rmdp-day.rmdp-selected span:not(.highlight), & .rmdp-day.rmdp-range span.sd, & .rmdp-day.rmdp-range-hover span.sd': {
            background: 'transparent',
            color: 'inherit',
            boxShadow: 'none',
        }, '& .b-deselect': {
            color: theme.palette.grey[600],
            backgroundColor: theme.palette.common.white,
        }, '& .rmdp-action-button': {
            color: theme.palette.primary.main,
        }, '& .rmdp-button:not(.rmdp-action-button)': {
            backgroundColor: theme.palette.primary.main,
        }, '& .rmdp-button:not(.rmdp-action-button):hover': {
            backgroundColor: theme.palette.grey[600],
        }, '& .rmdp-day.rmdp-range-hover.start, & .rmdp-day.rmdp-range.start': {
            borderBottomLeftRadius: '4px',
            borderTopLeftRadius: '4px',
            backgroundColor: theme.palette.primary.main,
            color: selectedText,
        }, '& .rmdp-day.rmdp-range-hover.end, & .rmdp-day.rmdp-range.end': {
            borderBottomRightRadius: '4px',
            borderTopRightRadius: '4px',
            backgroundColor: theme.palette.primary.main,
            color: selectedText,
        }, '& .rmdp-day.rmdp-range:has(.rmdp-single), & .rmdp-day.rmdp-range:has(.capital-range-edge), & .rmdp-day.rmdp-range.start.end': {
            borderRadius: 4,
            backgroundColor: theme.palette.primary.main,
            color: selectedText,
        } }, (isCapitalUI ? {
        maxWidth: '100%',
        borderRadius: capitalTokens.radius.popover,
        '&.rmdp-wrapper, &.rmdp-wrapper.rmdp-shadow': {
            background: theme.palette.background.paper,
            border: 0,
            boxShadow: 'none',
            color: theme.palette.text.primary,
            maxWidth: '100%',
        },
        '& .rmdp-top-class, & .rmdp-calendar': { maxWidth: '100%' },
        '& .rmdp-calendar': { padding: 8 },
        '& .rmdp-header': { height: 44, marginTop: 0 },
        '& .rmdp-header-values': { color: theme.palette.text.primary, fontSize: 14 },
        '& .rmdp-day, & .rmdp-week-day': { width: 38, height: 38, padding: 2 },
        '& .rmdp-week-day': { color: theme.palette.text.secondary, fontWeight: 600 },
        '& .rmdp-day span.sd': { fontSize: 13, fontWeight: 600 },
        '& .rmdp-arrow': { borderColor: theme.palette.primary.main, borderWidth: '0 2px 2px 0', marginTop: 14 },
        '& .rmdp-arrow-container': { width: 36, height: 36 },
        '& .rmdp-arrow-container:hover': { borderRadius: 12, background: theme.palette.action.hover },
        [theme.breakpoints.down('xs')]: {
            '& .rmdp-calendar': { padding: 4 },
            '& .rmdp-day, & .rmdp-week-day': { width: 36, height: 40 },
        },
    } : {}));
});
